import React from "react";
import ErrorContainer from "./ErrorContainer";

const Checkbox = ({
  label,
  formRegister,
  formError,
  formKey,
  isModal = false,
  onClick,
  notRequired,
  setCheckboxVal,
  setFormField,
  //
  checkboxVal = 0,
  checkedValue = 1,
  uncheckedValue = 0,
  //
  dynamicModalElementInfo,
  setModalInfo,
  dynamicModalInfo,
}) => {
  function changeLocalState() {
    setFormField(
      formKey,
      checkboxVal === checkedValue ? uncheckedValue : checkedValue
    );

    if (!dynamicModalInfo) {
      setCheckboxVal(
        checkboxVal === checkedValue ? uncheckedValue : checkedValue
      );
    } else {
      const inputElementsArr = dynamicModalInfo?.modalElements?.map(
        (element) => {
          if (element?.modalKey === dynamicModalElementInfo.modalKey) {
            return {
              ...dynamicModalElementInfo,
              defaultValue:
                checkboxVal === checkedValue ? uncheckedValue : checkedValue,
              // isChecked: isChecked ? false : true,
            };
          } else return element;
        }
      );

      setModalInfo({
        ...dynamicModalInfo,
        modalElements: inputElementsArr,
      });
    }
  }

  return (
    <li class="checkbox">
      <input
        onClick={changeLocalState}
        type="checkbox"
        checked={checkboxVal === checkedValue ? true : false}
        // value={isChecked}
        id={formKey}
      />
      <label for={formKey}>{label}</label>{" "}
    </li>
  );
};

export default Checkbox;
